import { Routes } from '@angular/router';
import { ProjectsComponent } from './components/projects/projects.component';

export const PROJECTS_ROUTES: Routes = [
  { path: 'projects', component: ProjectsComponent },
];
